/**
 *
 */
export type SamesiteValues = "None" | "Lax" | "Strict";

export const SAMESITE_VALUES = ["None", "Lax", "Strict"];
